import React, { useState } from "react";
import { useDispatch } from "react-redux";
import updateTitleThunk from "./../redux/todos/thunk/updateTitleThunk";

const TitleInput = ({ todo, setEditTitle }) => {
  const [inputText, SetInputText] = useState(todo.text);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    SetInputText(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await dispatch(updateTitleThunk(todo.id, inputText));
    setEditTitle({
      showInput: false,
      editId: "",
    });
  };

  const handleCancel = () => {
    setEditTitle({
      showInput: false,
      editId: "",
    });
  };
  return (
    <div className=' p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0'>
      <form className='md:w-9/12 w-full  ' onSubmit={handleSubmit}>
        <div className=' flex justify-start items-center gap-2 shadow appearance-none border rounded w-full bg-white md:ml-8  p-1 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'>
          <input className='w-full outline-0 p-1' autoFocus type='text' value={inputText} onChange={handleChange} />

          <button type='button' onClick={handleCancel}>
            <span className='material-symbols-outlined'>cancel</span>
          </button>
          <button type='submit'>
            <span className='material-symbols-outlined'>done</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default TitleInput;
